<template>
  <div class="page-wrap">
    <!-- ========== 新增顶部导航栏 ========== -->
    <div class="page-header">
      <div class="header-left">
        <!-- 移动端汉堡按钮 -->
        <div v-if="isMobile" class="hamburger-btn" @click="mobileMenuDrawer = true">
          <i class="el-icon-menu"></i>
        </div>
      </div>
      <div class="header-right">
        <!-- 系统消息图标 -->
        <div class="header-icon">
          <i class="el-icon-bell"></i>
        </div>
        <!-- 账户下拉菜单 -->
        <div v-if="visible_loginMenu">
          <el-dropdown trigger="click" @command="handleAccountCommand">
            <div class="header-icon user-icon">
              <i class="el-icon-s-custom"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="info">资产</el-dropdown-item>
              <el-dropdown-item command="logout" divided style="color: #f53f3f">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-else>
          <div class="header-icon user-icon" @click="login">
            <i class="el-icon-user"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- PC端：左侧导航 外层容器包裹两个组件 -->
     <div v-if="!isMobile" class="sidebar-wrap">
      <LeftSide :in-drawer="false" @openSubMenu="openSubMenu" />
    </div>
    <TopSide @openSubMenu="openSubMenu2" />
    <!-- 移动端左侧抽屉菜单 -->
    <el-drawer v-model="mobileMenuDrawer" direction="ltr" size="240px" :with-header="false">
      <LeftSide @openSubMenu="handleMobileSubMenu" />
    </el-drawer>

    <!-- 主体内容区域：【左侧表单 + 右侧标题+生成结果列表】 -->
    <div class="main-content">
      <div class="main-inner">
        <div class="replicate-layout">
          <!-- 左侧表单区域 -->
          <div class="form-panel">
            <!-- 参考产品图 -->
            <div class="form-item">
              <label class="form-label">上传产品图<span class="required">*</span></label>
              <div class="upload-card-wrap">
                <el-upload ref="uploadRefRef" action="" :auto-upload="false" :limit="5"
                  accept="image/jpeg,image/png,image/webp" :show-file-list="false" :on-change="handleRefDemoImgChange">
                  <div class="upload-card">
                    <i class="el-icon-upload"></i>
                    <div class="upload-tip">上传图片</div>
                    <div class="upload-desc">主图/详情图/场景图均可；传几张，出几张</div>
                  </div>
                </el-upload>
                <!-- 预览列表 -->
                <div class="img-preview-list" v-if="demoRefImgList.length > 0">
                  <div class="preview-item" v-for="(url, idx) in demoRefImgList" :key="idx">
                    <img :src="url" alt="" />
                    <i class="el-icon-close close-icon" @click="removeDemoRefImg(idx)"></i>
                  </div>
                </div>
                <div class="upload-count">{{ demoRefImgList.length }}/5</div>
              </div>
            </div>

            <!-- 你的商品图 -->
            <div class="form-item" v-if="type === '3'">
              <label class="form-label">你的商品图<span class="required">*</span></label>
              <div class="upload-card-wrap">
                <el-upload ref="uploadRefGoods" action="" :auto-upload="false" :limit="5"
                  accept="image/jpeg,image/png,image/webp" :show-file-list="false" :on-change="handleGoodsImgChange">
                  <div class="upload-card">
                    <i class="el-icon-upload"></i>
                    <div class="upload-tip">上传图片</div>
                    <div class="upload-desc">1张即可整套共用；多张商品则逐张生成</div>
                  </div>
                </el-upload>
                <div class="img-preview-list" v-if="goodsImgList.length > 0">
                  <div class="preview-item" v-for="(url, idx) in goodsImgList" :key="idx">
                    <img :src="url" alt="" />
                    <i class="el-icon-close close-icon" @click="removeGoodsImg(idx)"></i>
                  </div>
                </div>
                <div class="upload-count">{{ goodsImgList.length }}/5</div>
              </div>
            </div>

            <!-- 复刻程度 -->
            <div class="form-item" v-if="type === '3'">
              <label class="form-label">复刻程度</label>
              <div class="radio-group">
                <el-radio-group v-model="replicateMode">
                  <el-radio label="style">参考风格（借鉴调性，构图可变）</el-radio>
                  <el-radio label="full">高度复刻（照搬版式，仅替换产品）</el-radio>
                </el-radio-group>
              </div>
            </div>

            <!-- 平台 + 比例 -->
            <div class="form-item row-flex">
              <div class="form-col">
                <el-select v-model="selectedPlatform" placeholder="淘宝/天猫/阿里巴巴" size="small">
                  <el-option label="淘宝/天猫/阿里巴巴" value="taobao"></el-option>
                  <el-option label="京东/抖音/国内平台" value="jd_douyin"></el-option>
                  <el-option label="外贸电商平台" value="foreign"></el-option>
                </el-select>
              </div>
              <div class="form-col" v-if="true">
                <el-select v-model="selectedRatio" size="small">
                  <el-option label="1:1" value="1:1"></el-option>
                  <el-option label="3:4" value="3:4"></el-option>
                  <el-option label="9:16" value="9:16"></el-option>
                  <el-option label="16:9" value="16:9"></el-option>
                </el-select>
              </div>
            </div>

            <!-- 商品卖点&要求 -->
            <div class="form-item" v-if="type === '1' ? 5 : type === '2'">
              <label class="form-label">商品卖点&要求
                <el-button size="mini" icon="el-icon-magic-stick" @click="handleAiWrite">AI帮写</el-button>
              </label>
              <el-input v-model="goodsRequire" type="textarea" :rows="6" placeholder=""></el-input>
            </div>

            <!-- 操作按钮 -->
            <div class="form-item">
              <el-button type="primary" size="large" class="submit-btn" @click="runReplicateGenerate"
                :loading="generating">
                一键生成{{ type === '1' ? '商品主图' : type === '2' ? 'A+详情' : type === '3' ? '产品图复刻' : '商品主图' }}[{{ type ===
                  '1' ? 5 : type === '2' ? 10 : type === '3' ? 1 : '商品主图' }}张图片]
              </el-button>
            </div>
          </div>

          <!-- 右侧：标题 + 生成结果列表（替换原来示意图） -->
          <div class="preview-desc-panel">
            <div class="page-title">
              <h1>{{ type === '1' ? '商品主图' : type === '2' ? 'A+详情' : type === '3' ? '产品图复刻' : '商品主图' }}</h1>
              <p class="page-subtitle">上传产品图和参考图，AI 即刻生成保留商品主体特征的同款{{ type === '1' ? '商品主图' : type === '2' ? 'A+详情' :
                type === '3' ? '产品图复刻' : '商品主图' }}。</p>
            </div>

            <!-- 原来的demo-schema示意图已移除，这里直接放生成结果 -->
            <div class="result-section">
              <div class="tab-search-bar">
                <div class="tab-list">
                  <span class="tab" :class="{ active: currentTab === 'all' }" @click="currentTab = 'all'">全部</span>
                  <span class="tab" :class="{ active: currentTab === 'replicate' }"
                    @click="currentTab = 'replicate'">作品</span>
                </div>
                <el-input placeholder="搜索作品" style="width: 220px" v-if="false"></el-input>
              </div>
              <div class="waterfall-list">
                <div class="waterfall-item" v-for="(img, idx) in filterImgList" :key="idx"
                  @click="openImagePreview(img)">
                  <img :src="img.src" alt="" />
                  <div class="item-info">{{ img.text }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ========== 大图预览弹窗 ========== -->
    <div class="preview-mask" v-if="previewVisible" @click.self="closePreview">
      <div class="preview-box">
        <i class="el-icon-close preview-close" @click="closePreview"></i>
        <img class="preview-img" :src="currentPreviewImg.src" alt="" />
        <div class="preview-toolbar">
          <el-button type="primary" size="small" @click="downloadImage" v-if="isMember"> <i
              class="el-icon-download"></i> 下载保存 </el-button>
        </div>
      </div>
    </div>

    <!-- ========== 右侧抽屉：电商图子菜单 ========== -->
    <el-drawer :visible.sync="subDrawerVisible" direction="rtl" size="260px" title="电商图设计"
      :before-close="closeSubDrawer">
      <div class="sub-menu-list">
        <div class="sub-menu-item" v-for="subItem in subMenuList" :key="subItem.path" @click="goPage(subItem.path)">
          <i :class="subItem.icon"></i>
          <span>{{ subItem.title }}</span>
        </div>
      </div>
    </el-drawer>

    <div class="float-input-panel" :class="{ hidePanel: !showBottomInput }">
      <div class="float-input-box">
        <div class="float-input-left">
          <i class="el-icon-plus float-add-icon"></i>
        </div>
        <textarea class="float-textarea" placeholder='输入想法、剧本或上传参考，支持 "/" 使用技能，@ 添加主体，和Agent一起创作'></textarea>
        <div class="float-input-right">
          <el-button size="mini" class="float-btn">
            <i class="el-icon-microphone"></i>
          </el-button>
          <el-button type="primary" class="float-send-btn">
            <i class="el-icon-top"></i>
          </el-button>
        </div>
      </div>
      <div class="float-quick-tags">
        <span class="quick-tag">智能生成</span>
        <span class="quick-tag">图片生成</span>
        <span class="quick-tag">视频生成</span>
        <span class="quick-tag">数字人</span>
        <span class="quick-tag">商品图</span>
      </div>
    </div>
  </div>
</template>
<script>
import TopSide from '@/components/TopSide.vue'
import LeftSide from '@/components/LeftSide.vue'
export default {
  components: { LeftSide, TopSide },
  props: ['type'], // 页面类型 1=商品主图，2=A+详情，3=爆款复刻
  data() {
    return {
      visible_loginMenu: !!window.sessionStorage.getItem('token'),
      isMobile: false,
      isMember: parseInt(window.sessionStorage.getItem('isMember')) > 0, // 是否是会员
      mobileMenuDrawer: false,
      generating: false,
      subDrawerVisible: false,
      showBottomInput: false,

      // 爆款复刻业务
      demoRefImgList: [], // 参考产品图预览url
      demoRefFileList: [], // 参考图file对象
      goodsImgList: [], // 你的商品图预览url
      goodsFileList: [], // 商品图file对象
      replicateMode: 'style', // style参考风格 / full高度复刻
      selectedPlatform: 'taobao',
      selectedRatio: '16:9',
      goodsRequire: '', // 商品卖点输入框

      // 作品预览弹窗
      previewVisible: false,
      currentPreviewImg: {},

      // tab
      currentTab: 'all',
      imgList: [],

      subMenuList: [
        { title: '商品主图', icon: 'el-icon-picture', path: '/zhutu' },
        { title: 'A+详情', icon: 'el-icon-document', path: '/xiangqing' },
        { title: '产品图复刻', icon: 'el-icon-s-platform', path: '/baokuang' }
      ]
    }
  },

  created() {
    // 根据type读取独立缓存
    console.log(9999, this.type)
    const cacheStr = window.sessionStorage.getItem(this.storageKey)
    if (cacheStr) {
      try {
        this.imgList = JSON.parse(cacheStr)
      } catch (e) {
        console.warn('缓存解析失败')
        this.imgList = []
      }
    } else {
      this.imgList = []
    }
  },
  computed: {
    // 动态生成当前页面专属缓存key
    storageKey() {
      return `replicateImgList_type_${this.type}`
    },
    filterImgList() {
      if (this.currentTab === 'all') return this.imgList
      return this.imgList.filter((img) => img.type === 'replicate')
    }
  },
  mounted() {
    this.checkDevice()
    window.addEventListener('resize', this.checkDevice)
    window.addEventListener('scroll', this.debounceCheckScroll)
    this.checkScroll()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice)
    window.removeEventListener('scroll', this.debounceCheckScroll)
    // 释放blob
    this.demoRefImgList.forEach((u) => URL.revokeObjectURL(u))
    this.goodsImgList.forEach((u) => URL.revokeObjectURL(u))
  },
  methods: {
    // -------- 上传处理：参考产品图 --------
    handleRefDemoImgChange(file) {
      if (!file.raw) return
      const maxSize = 5 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.warning('图片不能大于5MB')
        return
      }
      this.demoRefFileList.push(file.raw)
      this.demoRefImgList.push(URL.createObjectURL(file.raw))
    },
    removeDemoRefImg(idx) {
      URL.revokeObjectURL(this.demoRefImgList[idx])
      this.demoRefImgList.splice(idx, 1)
      this.demoRefFileList.splice(idx, 1)
    },

    // -------- 上传处理：你的商品图 --------
    handleGoodsImgChange(file) {
      if (!file.raw) return
      const maxSize = 5 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.warning('图片不能大于5MB')
        return
      }
      this.goodsFileList.push(file.raw)
      this.goodsImgList.push(URL.createObjectURL(file.raw))
    },
    removeGoodsImg(idx) {
      URL.revokeObjectURL(this.goodsImgList[idx])
      this.goodsImgList.splice(idx, 1)
      this.goodsFileList.splice(idx, 1)
    },

    /**
     * AI帮写：上传参考图片，调用大模型视觉能力，生成商品卖点，追加平台要求
     */
    async handleAiWrite() {
      if (this.aiWriting) return
      const guestMob = window.sessionStorage.getItem('guest_mob') || ''
      if (this.generating) return
      if (guestMob.length === 0) {
        this.$router.push('/mob')
        return
      }

      if (this.demoRefFileList.length === 0) {
        this.$message.warning('请先上传【产品图】，AI基于图片生成卖点')
        return
      }
      const platformMap = {
        taobao: '用于淘宝天猫1688风格的图片',
        jd_douyin: '用于京东抖音国内电商的图片',
        foreign: '用于外贸跨境电商，要求纯英文版本的设计图'
      }
      const platformSuffix = platformMap[this.selectedPlatform]

      this.aiWriting = true
      try {
        const formData = new FormData()
        // 重点修复：element‑ui/upload 文件列表，取 .raw 获取原生File对象！
        this.demoRefFileList.forEach((f) => {
          // 如果是el‑upload，真实文件在 raw 属性；直接append(f)会传占位对象
          const realFile = f.raw || f
          formData.append('images', realFile)
        })
        formData.append('platform', this.selectedPlatform)
        let prompt = ''
        if (this.type === '1' || this.type === '2') prompt = '仔细观察这张产品实物图片，识别产品是什么，提取图片上看得见的硬件、结构、外观、工艺细节，生成5‑8条电商短卖点，每条简短有力，适合做主图标签，不要编造图片不存在的功能。输出格式：产品名称+卖点列表。'
        else prompt = '图生图复刻爆款电商主图，严格参考参考图的构图、拍摄角度、布光、背景色调、景深、画面布局、文字排版位置。主体替换为我的产品，100%保留产品原有外形、结构、细节纹理，不篡改产品样貌，不扭曲变形。商业静物摄影，高级柔光，明暗层次和参考爆款图保持一致，干净通透，高清，细节锐利，电商平台爆款风格，低AI畸变，禁止改变产品本体。'
        formData.append('prompt', prompt)

        const res = await this.$http.post('/api/ai_image2text', formData)
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg || 'AI生成卖点失败')
          return
        }
        const aiText = res.data.data.content || ''
        if (!aiText.trim()) {
          this.$message.warning('AI未能识别图片卖点，请更换图片重试')
          return
        }
        this.goodsRequire = aiText.trim() + '\n' + platformSuffix
        this.$message.success('AI已根据图片生成卖点')
      } catch (err) {
        console.error('ai帮写异常', err)
        this.$message.error('AI调用异常，请稍后重试')
      } finally {
        this.aiWriting = false
      }
    },

    // 一键复刻产品图
    async runReplicateGenerate() {
      if (this.generating) return
      const guestMob = window.sessionStorage.getItem('guest_mob') || ''
      if (this.generating) return
      if (guestMob.length === 0) {
        this.$router.push('/mob')
        return
      }

      if (this.demoRefFileList.length === 0) {
        this.$message.warning('请上传参考产品图')
        return
      }
      if (this.goodsFileList.length === 0 && this.type === 3) {
        this.$message.warning('请上传你的产品图')
        return
      }
      if (!this.goodsRequire.trim() && (this.type === '1' || this.type === '2')) {
        this.$message.warning('请填写商品卖点&要求')
        return
      }

      this.generating = true
      try {
        this.userPrompt = this.goodsRequire
        const { data: resCheck } = await this.$http.post('api', {
          C_type: 'ai_upload',
          content: this.userPrompt,
          guest_mob: guestMob,
          type: parseInt(this.type) + 3
        })

        if (resCheck.status === 202) {
          this.$message.error('余额不足，请充值')
          // 移除加载消息
          this.chatList.pop()
          return
        }

        const formData = new FormData()
        // 多参考图
        this.demoRefFileList.forEach((f) => formData.append('ref_demo_images', f))
        // 商品图
        this.goodsFileList.forEach((f) => formData.append('goods_images', f))
        let picCount = 0
        if (this.type === '1') picCount = 5
        else if (this.type === '2') picCount = 10
        else picCount = 1
        const lqs0 = '图生图复刻爆款电商主图，严格参考参考图的构图、拍摄角度、布光、背景色调、景深、画面布局、文字排版位置。主体替换为我的产品，100%保留产品原有外形、结构、细节纹理，不篡改产品样貌，不扭曲变形。商业静物摄影，高级柔光，明暗层次和参考爆款图保持一致，干净通透，高清，细节锐利，电商平台爆款风格，低AI畸变，禁止改变产品本体。'
        let lqs = ',请生成' + picCount.toString() + '张图片。'
        if (this.type === '3') lqs = lqs + '其中 要求把第1张图的主体,替换成第二张的主体。'
        formData.append('replicate_mode', this.replicateMode)
        formData.append('platform', this.selectedPlatform)
        formData.append('aspect_ratio', this.selectedRatio)
        formData.append('prompt', lqs0 + this.goodsRequire + lqs)
        formData.append('guest_mob', guestMob)
        formData.append('count', this.type === '1' ? 5 : this.type === '2' ? 10 : 1)
        // 这里替换成你的后端接口 ,复刻 用多图 生成多图
        const httpStr = this.type === '1' || this.type === '2' ? '/api/image-images' : '/api/images-image'
        const res = await this.$http.post(httpStr, formData)
        if (res.data.code === 200) {
          const imageList = res.data.data.data

          if (!Array.isArray(imageList) || imageList.length === 0) {
            this.$message.error('生成结果为空，请重试')
            return
          }
          imageList.forEach((imageData) => {
            this.imgList.unshift({
              src: imageData.url,
              text: this.goodsRequire,
              type: 'replicate'
            })
          })
          window.sessionStorage.setItem(this.storageKey, JSON.stringify(this.imgList))
          this.$message.success(`成功生成 ${imageList.length} 张主图！`)
        } else {
          this.$message.error(res.data.msg || '生成失败')
        }
      } catch (err) {
        console.error(err)
        this.$message.error('网络异常，请稍后重试')
      } finally {
        this.generating = false
      }
    },

    checkDevice() {
      this.isMobile = window.innerWidth <= 768
      if (this.isMobile) this.mobileMenuDrawer = false
    },
    debounceCheckScroll: (function () {
      let timer = null
      return function () {
        clearTimeout(timer)
        timer = setTimeout(() => this.checkScroll(), 100)
      }
    })(),
    checkScroll() {
      this.showBottomInput = window.scrollY > 120
    },

    handleMobileSubMenu() {
      this.openSubMenu()
      this.mobileMenuDrawer = false
    },
    openSubMenu() {
      this.subDrawerVisible = true
    },
    openSubMenu2() { },
    closeSubDrawer(done) {
      done()
    },
    goPage(routePath) {
      this.$router.push(routePath)
      this.subDrawerVisible = false
    },

    openImagePreview(imgItem) {
      this.currentPreviewImg = imgItem
      this.previewVisible = true
      document.body.style.overflow = 'hidden'
    },
    closePreview() {
      this.previewVisible = false
      document.body.style.overflow = ''
    },
    async downloadImage() {
      try {
        const imgUrl = this.currentPreviewImg.src
        const a = document.createElement('a')
        a.href = imgUrl
        a.download = '生成图'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } catch (err) {
        this.$message.info('图片存在跨域限制，请右键图片另存为')
      }
    },

    handleAccountCommand(command) {
      switch (command) {
        case 'info':
          this.$router.push('/zichan')
          break
        case 'logout':
          this.exit()
          this.$message.success('退出登录')
          break
      }
    },
    login() {
      this.$router.push('/mob')
    },
    exit() {
      window.sessionStorage.setItem('token', '')
      window.sessionStorage.setItem('tokenUserType', 0)
    }
  }
}
</script>

<style scoped>
.page-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  z-index: 99;
  background: #fff;
}

.header-left {
  display: flex;
  align-items: center;
}

.hamburger-btn {
  width: 36px;
  height: 36px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  border: 1px solid #e8edf2;
  color: #666;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #666;
  cursor: pointer;
  border: 1px solid #e8edf2;
}

.header-icon:hover {
  color: #22b8e6;
  border-color: #ccebfa;
}

.sidebar-wrap {
  width: 120px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.page-wrap {
  background-color: #fbfcfd;
  min-height: 100vh;
  padding-top: 56px;
  display: flex;
}

.main-content {
  flex: 1;
  padding: 24px 20px;
  box-sizing: border-box;
}

.main-inner {
  max-width: 1300px;
  margin: 0 auto;
  width: 100%;
}

/* 核心布局：左侧表单 + 右侧结果区域 */
.replicate-layout {
  display: flex;
  gap: 32px;
  margin-bottom: 40px;
  align-items: flex-start;
}

.form-panel {
  width: 420px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e8edf2;
}

.preview-desc-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  padding-right: 4px;
}

.page-title h1 {
  font-size: 24px;
  text-align: center;
  margin: 0 0 6px;
  color: #222;
}

.page-subtitle {
  text-align: center;
  color: #666;
  margin: 0 0 20px;
  font-size: 14px;
}

.form-item {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
}

.required {
  color: #f56c6c;
}

.row-flex {
  display: flex;
  gap: 12px;
}

.form-col {
  flex: 1;
}

.upload-card-wrap {
  position: relative;
}

.upload-card {
  border: 1px dashed #c0c4cc;
  border-radius: 8px;
  padding: 20px 12px;
  text-align: center;
  cursor: pointer;
  color: #909399;
}

.upload-card i {
  font-size: 24px;
}

.upload-tip {
  margin: 6px 0 4px;
}

.upload-desc {
  font-size: 12px;
  color: #aaa;
}

.upload-count {
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 12px;
  color: #999;
}

.img-preview-list {
  display: flex;
  gap: 8px;
  margin-top: 10px;
  flex-wrap: wrap;
}

.preview-item {
  width: 64px;
  height: 64px;
  position: relative;
}

.preview-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #ddd;
}

.close-icon {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 18px;
  height: 18px;
  background: #333;
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.submit-btn {
  width: 100%;
}

.result-section {
  flex: 1;
}

.tab-search-bar {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.tab-list {
  display: flex;
  gap: 24px;
}

.tab {
  font-size: 15px;
  color: #777;
  cursor: pointer;
  padding: 4px 0;
}

.tab.active {
  color: #22b8e6;
  border-bottom: 2px solid #22b8e6;
}

.waterfall-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

.waterfall-item {
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  cursor: pointer;
  transition: transform 0.2s;
}

.waterfall-item:hover {
  transform: scale(1.02);
}

.waterfall-item img {
  width: 100%;
  display: block;
}

.item-info {
  padding: 8px;
  font-size: 13px;
  color: #333;
}

/* 预览弹窗 */
.preview-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.82);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
}

.preview-box {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.preview-close {
  position: absolute;
  top: -36px;
  right: 0;
  font-size: 26px;
  color: #fff;
  cursor: pointer;
}

.preview-img {
  max-width: 100%;
  max-height: 82vh;
  border-radius: 6px;
  display: block;
}

.preview-toolbar {
  text-align: center;
  margin-top: 14px;
}

.sub-menu-list {
  padding-top: 12px;
}

.sub-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  border-radius: 8px;
  margin-bottom: 4px;
}

.sub-menu-item:hover {
  background: #f0f9fe;
  color: #22b8e6;
}

.sub-menu-item i {
  font-size: 16px;
}

/* 底部悬浮输入 */
.float-input-panel {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 16px 24px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: opacity 0.25s ease, transform 0.25s ease;
  opacity: 1;
  transform: translateY(0);
}

.float-input-panel.hidePanel {
  opacity: 0;
  transform: translateY(20px);
  pointer-events: none;
}

.float-input-box {
  width: 100%;
  max-width: 820px;
  background: #ffffff;
  border: 1px solid #e8edf2;
  border-radius: 16px;
  padding: 12px 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.float-input-left {
  width: 36px;
  height: 36px;
  background: #f5f7fa;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 4px;
}

.float-add-icon {
  color: #999;
  font-size: 16px;
}

.float-textarea {
  flex: 1;
  border: none;
  outline: none;
  resize: none;
  height: 42px;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

.float-textarea::placeholder {
  color: #999;
}

.float-input-right {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.float-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #dde5ee;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.float-send-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #22b8e6;
  border: none;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.float-quick-tags {
  width: 100%;
  max-width: 820px;
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.quick-tag {
  font-size: 13px;
  color: #666;
  background: #f5f7fa;
  border: 1px solid #e8edf2;
  border-radius: 20px;
  padding: 6px 10px;
  cursor: pointer;
}

.quick-tag:hover {
  color: #22b8e6;
  border-color: #ccebfa;
  background: #f0f9fe;
}

/* 响应式 */
@media (max-width: 1024px) {
  .waterfall-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .replicate-layout {
    flex-direction: column;
  }

  .form-panel {
    width: 100%;
  }

  .preview-desc-panel {
    max-height: unset;
    overflow-y: visible;
  }

  .waterfall-list {
    grid-template-columns: repeat(2, 1fr);
  }

  .row-flex {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .waterfall-list {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
